<template>
    <button class="dropdown-item"
       @click="$emit('click')">
        <i :class="`fas fa-${icon}`" v-if="icon"></i>
        {{ text }}
    </button>
</template>

<script>
    export default {
        name: "ButtonDropdownItem",
        props: ['text', 'icon'],
    }
</script>

<style scoped>

</style>
